export const EDIT_LOCATION_CRITERIA_REQUEST = 'EDIT_LOCATION_CRITERIA_REQUEST';
export const EDIT_LOCATION_CRITERIA_SUCCESS = 'EDIT_LOCATION_CRITERIA_SUCCESS';
export const EDIT_LOCATION_CRITERIA_FAILURE = 'EDIT_LOCATION_CRITERIA_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/redux/constants/update_location_criteria.constants.js